import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Grid,
  Typography,
  Paper,
} from "@mui/material";
import { Delete as DeleteIcon, Add as AddIcon } from "@mui/icons-material";
import AWS from "aws-sdk";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import awsExports from "../../aws-exports";
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
// import Auth from "@aws-amplify/auth";

const roles = [
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
  { value: "parkingManager", label: "Parking Manager" },
];
Amplify.configure(awsExports);

const InviteUsers = () => {
  const [users, setUsers] = useState([{ email: "", role: "user" }]);

  const handleUserChange = (index, field, value) => {
    const updatedUsers = [...users];
    updatedUsers[index][field] = value;
    setUsers(updatedUsers);
  };

  const addUser = () => {
    setUsers([...users, { email: "", role: "user" }]);
  };

  const removeUser = (index) => {
    const updatedUsers = users.filter((_, i) => i !== index);
    setUsers(updatedUsers);
  };

  const inviteUsers = async () => {
    try {
      const session = await fetchAuthSession(); // Fetch the authentication session
      const accessToken = session.tokens.accessToken.toString();
      const idToken =session.tokens.idToken.toString();
      // console.log("ID Token:", session.tokens.idToken.toString());
      // console.log(token);
      const response = await fetch("https://blue-parking-invite.bluept.dev/invite", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}`, id_token: idToken, "X-Api-Key": "mvWKj9O2vy3i6SaRrqKjR9dJIfNPTUgO7ReZ4esz" },
        body: JSON.stringify(users),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Failed to invite user");
      }
      alert(data.message);
    } catch (error) {
      // alert(`Failed to invite ${user.email}: ${error.message}`);
      console.error(error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Paper elevation={3} sx={{ padding: 4, margin: 4 }}>
        <Typography sx={{ color: "#000" }} variant="h5" gutterBottom>
          Invite Users
        </Typography>
        <Box sx={{ marginBottom: 2 }}>
          {users.map((user, index) => (
            <Grid container spacing={2} alignItems="center" key={index}>
              <Grid item xs={6}>
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#000", // Change label color
                    },
                    "& .MuiInputBase-input": {
                      color: "#000", // Customize input text color
                    },
                  }}
                  InputLabelProps={{
                    sx: { color: "#000" }, // Change label color here
                  }}
                  value={user.email}
                  onChange={(e) => handleUserChange(index, "email", e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  label="Role"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#000", // Change label color
                    },
                    "& .MuiInputBase-input": {
                      color: "#000", // Customize input text color
                    },
                    width: "150px",
                    color: "#000",
                  }}
                  value={user.role}
                  onChange={(e) => handleUserChange(index, "role", e.target.value)}
                >
                  {roles.map((role) => (
                    <MenuItem key={role.value} value={role.value}>
                      {role.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  color="error"
                  onClick={() => removeUser(index)}
                  disabled={users.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          <Button startIcon={<AddIcon />} variant="contained" onClick={addUser} color="primary">
            Add Another User
          </Button>
        </Box>
        <Button
          variant="contained"
          color="success"
          onClick={inviteUsers}
          disabled={users.some((user) => !user.email)}
          sx={{ color: "#fff", backgroundColor: "green",    "&:hover": { backgroundColor: "green" } }}
        >
          Send Invitations
        </Button>
      </Paper>
    </DashboardLayout>
  );
};

export default InviteUsers;
